<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import questionnaire from './../libs/questionnaire.json';
  import { answers } from './../libs/stores.js';
  import { toConfig, computeScores, computeResultId, exportAnswerObject } from './../libs/utils.js';
  
  import Footer from "./../components/Footer.svelte";

  let current_page = 0;
  let answer_missing = false;
  let sections = questionnaire

  function check_answers() {
    let section = sections[current_page];
    let all_answered = section.questions.every(e => e.a != undefined);

    if (all_answered) {
      answer_missing = false;
    } else {
      answer_missing = true;
    }

    return all_answered;
  }

  function handle_next(ev) {
    if (check_answers()) current_page++;

    window.scrollTo(0, 0); // go back to top
  }

  async function handle_finish(ev) {
    if (check_answers()) {
      let scores = computeScores(sections);
      let config_pattern = Array(questionnaire.length).fill(true);
      config_pattern[0] = false; // the first section should be ignored
      let config = toConfig(config_pattern);

      $answers.a = exportAnswerObject(sections, 'q');
      navigate("/p/" + computeResultId(config, scores));
    }

    window.scrollTo(0, 0); // go back to top
  }

</script>

<div>

  <!-- navbar -->
  <div class="navbar bg-neutral-content flex-col sm:flex-row">
    <div class="flex-1">
      <h1 class="text-2xl font-bold ml-4">Business2030
          <small class="opacity-30"> 
              S<span class="hidden md:inline">elf</span><!--
              --><span class="hidden md:inline">-</span><!--
              -->A<span class="hidden md:inline">assessment</span>
              T<span class="hidden md:inline">ool</span>
          </small>
      </h1>
    </div>
    
    <div class="flex-none mt-2 mb-4 sm:my-0 sm:mx-4 w-full sm:w-auto overflow-y-auto">

      <ul class="steps">
        {#each sections as section, index}
          <li class="step" class:step-secondary={index <= current_page}></li>
        {/each}
        <li class="step"></li>
      </ul>

    </div>
  </div>
  
  <!-- content -->
  <div class="container px-4 sm:px-0 pt-6 pb-16 sm:mx-auto prose">

    {#each sections as section, s_index}
      <div class:hidden={s_index != current_page}>

        <!-- alert -->
        <div class="alert alert-error shadow-lg" class:hidden={!answer_missing}>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span> {$_('questionnaire.answer_required')} </span>
          </div>
        </div>

        <h2 class="text-center mb-16"> {$_(section.section)} </h2>

        {#each section.questions as question, q_index}
          <!-- question -->
          <div class="mt-4">
            <h4>{$_('questionnaire.question')} {q_index + 1}
              <span class="text-success" class:hidden={question.a == undefined}>✓</span>
            </h4>
            <p class="text-justify"> {$_(question.q)} </p>

            {#if Array.isArray(question.o)}
              <div class="ml-4 sm:ml-6">
                {#each question.o as option, o_index}
                  <div class="form-control">
                    <label class="label cursor-pointer justify-start">
                      <input type="radio" name="r-{s_index}-{q_index}" class="radio checked:bg-primary" value={question.s[o_index]} bind:group={question.a} />
                      <span class="label-text ml-4"> {$_(option)} </span>
                    </label>
                  </div>
                {/each}
              </div>
            {:else}
              <div class="flex justify-center">
                  <div class="rating" class:opacity-25={question.a == undefined}>
                    {#each question.s as score}
                      <input type="radio" name="r-{s_index}-{q_index}" class="mask mask-star-2 bg-orange-400" value={score} bind:group={question.a} />
                    {/each}
                  </div>
              </div>
            {/if}
          </div>
        {/each}

      </div>
    {/each}
  </div>

  <!-- buttons -->
  <div class="w-5/6 lg:w-1/3 mx-auto mt-4 mb-8 flex justify-between flex-row-reverse">
    <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com
    License - https://fontawesome.com/license (Commercial License)
    Copyright 2022 Fonticons, Inc. -->
  
    {#if current_page != sections.length - 1}
      <button class="btn btn-secondary gap-2" on:click={handle_next}>
        Next <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 256 512" fill="currentColor"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg>
      </button>
    {:else}
      <button class="btn btn-secondary gap-2" on:click={handle_finish}>
        Next <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 256 512" fill="currentColor"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg>
      </button>
    {/if}
  </div>

  <Footer/>

</div>

